import { useCallback, useEffect, useState } from "react";

/**
 * Custom hook to check if the browser tab is currently active (visible).
 * @returns {boolean} True if the tab is visible, false otherwise.
 */
const useIsTabActive = () => {
  const [isTabVisible, setIsTabVisible] = useState(!document.hidden);

  const handleVisibilityChange = useCallback(() => {
    setIsTabVisible(!document.hidden);
  }, []);

  const handleFocus = useCallback(() => setIsTabVisible(true), []);
  const handleBlur = useCallback(() => setIsTabVisible(false), []);

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);
    window.addEventListener("pageshow", handleFocus);
    window.addEventListener("pagehide", handleBlur);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
      window.removeEventListener("pageshow", handleFocus);
      window.removeEventListener("pagehide", handleBlur);
    };
  }, [handleVisibilityChange, handleFocus, handleBlur]);

  return isTabVisible;
};

export default useIsTabActive;
